<form novalidate [formGroup]="_form" (keydown.enter)="$event.preventDefault()" class="form_style">
  <div class="row">
    <div class="col-12">
      <div class="transaction-section-header">
        <div class="transaction-section-header-title">Pack</div>
        <div class="transaction-section-header-actions header-actions">
          <!-- <button
          [class.ViewModeHiddenElement]="_pageState != 2"
          class="hidden-xs asap-btn"
          kendoButton
          (click)="_editFormState()"
          >
          <span
            ><img [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" /></span
            >Edit Form
          </button> -->
          <!-- <button
          [class.ViewModeHiddenElement]="_pageState != 4"
          class="hidden-xs asap-btn"
          kendoButton
          (click)="_returnAddNew()"
          >
          <span
            ><img [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" /></span
            >Close Edit Form
          </button> -->
          <button class="hidden-xs asap-btn" kendoButton (click)="_printReceiptReport()">
            <span><img [src]="'/assets/menu/'+ _theme +'/print-icon.svg'" /></span>Print
          </button>
          <button class="hidden-xs asap-btn" kendoButton (click)="_onSave($event)">
            <span><img [src]="'/assets/menu/'+ _theme +'/proccess-icon.svg'" /></span>Process
          </button>
          <button class="hidden-xs asap-btn" kendoButton (click)="_onClear()">
            <span><img [src]="'/assets/menu/'+ _theme +'/clear-icon.svg'" /></span>Clear
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row no-row-margin">
    <div class="col-12 ">
      <div class="transactionWidget">
        <div class="row no-row-margin">
          <div class="col-12 col-lg-6 zeroPaddingColumn">
            <div class="row">
              <div class="col-12">
                <p class="titleStandardStyle">General Information</p>
              </div>
              @if (_currentUser && _currentUser.isEnterprise) {
                <div class="col-12">
                  <div class="form-group special_style_formgroup">
                    <div class="row">
                      <div class="col-2"><label class="control-label">Account</label></div>
                      <div class="col-10 transaction--input-fields">
                        <accounts-dropdown #kendo_combo_accounts
                          [formControl]="_selectedAccount"
                          class="bordered current-step newFormControlWidth"
                          [class.active]="_selectedAccount.value == null"
                          [required]="true">
                        </accounts-dropdown>
                      </div>
                    </div>
                    <div class="transaction--stock-right-checkbox empty-small"></div>
                  </div>
                </div>
              }
              <sites-dropdown #kendo_combo_sites
                layout="transaction"
                [forceShow]="_isMultiSiteSelected"
                [labelText]="'Site'"
                [inputContainerClass]="'transaction--input-fields'"
                formControlName="site"
                [placeholder]="'Choose a Site'"
                [textField]="'name'"
                [valueField]="'id'"
                [class]="'bordered current-step newFormControlWidth'"
                [required]="true">
              </sites-dropdown>
              <div class="col-12">
                <div class="form-group special_style_formgroup">
                  <div class="row">
                    <div class="col-2">
                      <!-- <label class="control-label">{{_packAgainstSO ? 'Sales Order'
                    : 'Pack List #'}}</label> -->
                    @if (!_packAgainstSO) {
                      <label class="control-label">{{getLabel('LBL_PackListNumber')?.currentText}}</label>
                    }
                    @if (_packAgainstSO) {
                      <label class="control-label">{{getLabel('LBL_SalesOrder')?.currentText}}</label>
                    }
                  </div>
                  <div class="col-10 transaction--input-fields">
                    @if (!_packAgainstSO) {
                      <kendo-combobox #kendo_combo_Pack_list
                        [data]="_packListFiltered" [filterable]="true" [suggest]="true"
                        formControlName="packList"
                        (selectionChange)="_handlePackListsSelection($event)"
                        [placeholder]="'Choose a Pack List #'" [textField]="'packingListNumber'"
                        [valueField]="'id'" class="bordered" required>
                      </kendo-combobox>
                    }
                    @if (!_packAgainstSO) {
                      <a
                        [class.editfieldsIconvisible]="_pageState == 4"
                        class="editFieldsIcon"
                        (click)="_openRenameForm('LBL_PackListNumber', false, true)">
                        <img class="searchIcon"
                          style="margin-left:30px;"
                          [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                        </a>
                      }
                      @if (_packAgainstSO) {
                        <kendo-combobox #kendo_combo_Pack_list
                          [data]="_packListFiltered"
                          [filterable]="true"
                          [suggest]="true"
                          formControlName="salesOrder"
                          (selectionChange)="_handlePackListsSelection($event)"
                          [placeholder]="'Choose a Sales Order'"
                          [textField]="'Concat'"
                          [valueField]="'transactionNumber'" class="bordered" required>
                        </kendo-combobox>
                      }
                      @if (_packAgainstSO) {
                        <a
                          [class.editfieldsIconvisible]="_pageState == 4"
                          class="editFieldsIcon"
                          (click)="_openRenameForm('LBL_SalesOrder', false, true)">
                          <img class="searchIcon"
                            style="margin-left:30px;"
                            [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                          </a>
                        }

                      </div>
                    </div>
                    <div class="transaction--stock-right-checkbox empty-small"></div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group special_style_formgroup">
                    <div class="row">
                      <div class="col-2"><label class="control-label">{{getLabel('LBL_TransactionNotes')?.currentText}}</label></div>
                      <div class="col-10 transaction--input-fields">
                        <input #Kendo_Input_Transaction_note type="text" formControlName="notes"
                          class="k-textbox writebox newFormControlWidth"
                          (focus)="_focustransactionNotes()"
                          (focusout)="_focusOutTransactionNotes()"
                          placeholder="Transaction Notes.." />
                          <span class="inputSkipButton" (click)="_skipTransactionNotes()">
                            skip<img [src]="'/assets/menu/'+ _theme +'/yellow-skip-arrow.svg'" />
                          </span>
                          <a [class.editfieldsIconvisible]="_pageState == 4"
                            class="editFieldsIcon"
                            (click)="_openRenameForm('LBL_TransactionNotes', false, true)">
                            <img class="searchIcon"
                              style="margin-left:30px;"
                              [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                            </a>
                          </div>

                        </div>
                        <div class="transaction--stock-right-checkbox empty-small"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="transactionWidget with-grid numericboxtab" [class.active]="_addClassActive">
              <div class="flex-space-between transaction--grid-header-wrapper">
                <p class="titleStandardStyle">Selected Items</p>
                <div class="transaction--grid-top-actions">
                  <div class="transaction--grid-top-actions-radio">
                    <input type="radio" id="new-to-old-items" name="transaction--duration" value="new"
                      [formControl]="_sortingSelected" kendoRadioButton />
                      <label class="k-radio-label" [for]="'new-to-old-items'">Newest To Oldest</label>
                    </div>
                    <div class="transaction--grid-top-actions-radio">
                      <input type="radio" id="old-to-new-items" name="transaction--duration" value="old"
                        [formControl]="_sortingSelected" kendoRadioButton />
                        <label class="k-radio-label" [for]="'old-to-new-items'">Oldest To Newest</label>
                      </div>
                    </div>
                  </div>

                  <kendo-grid [data]="_inventoryGridData" [scrollable]="'none'" class="transaction--grid">

                    <kendo-grid-column field="transactionNumber" title="Transaction #">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.transactionNumber | number: '9.0' | removeComma}}
                      </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-column field="historyDate" title="History Date">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.historyDate | dateFormat}}
                      </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-column field="inventoryCode" title="Inventory ID">
                    </kendo-grid-column>

                    <kendo-grid-column field="itemNumber" title="Stock Item #">
                    </kendo-grid-column>

                    <kendo-grid-column field="locationCode" title="Location ID">
                    </kendo-grid-column>

                    <kendo-grid-column field="customerCode" title="Customer ID">
                    </kendo-grid-column>

                    <kendo-grid-column field="quantityChange" title="Quantity Change">
                    </kendo-grid-column>

                  </kendo-grid>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                @if (_invalidForm) {
                  <asap-forms-validation-summary [form]="_form" [page]="'pack'">
                  </asap-forms-validation-summary>
                }
              </div>
            </div>
          </form>

          @if (_editFormActive) {
            <kendo-window
              title="{{ _isCustomfieldsFormValue ? 'Add Custom Fields' : (_isAddTabFormValue ? 'Add New Tabs' : (_isRenameFormValue ? 'Edit Record: ' +_selectedLabelText : '')) }}"
              (close)="_closeCustomFields()"
              class="customFieldsWindow">
              <asap-custom-fields [accounts]="_selectedAccountIds"
                [labelObjectCode]="_selectedLabelObjectCode"
                [formName]="'stock'"
                [page]="_page"
                [isCustomfieldsForm]="_isCustomfieldsFormValue"
                [isCustomtabsForm]="_isAddTabFormValue"
                [isRenameForm]="_isRenameFormValue"
                [language]="_language"
                [isRenameCustomForm]="_isRenameCustomFormValue"
                [onlyRequired]="_onlyRequired"
                [hasRequired]="_hasRequired"
                [isRenameLabel]="_isRenameLabel"
                [isMandatory]="_isMandatory"
                [isTransaction]="_isTransaction"
                (closePopup)="ClosePopup($event)"
                [permissionScope]="'packTransaction'">
              </asap-custom-fields>
            </kendo-window>
          }
